import React, { memo,
    //, useEffect, useState,
        } from 'react';
import AppWebReportStundenPage from "./AppWebReportStundenPage";
import AppWebReportTaetigkeitsberichtPage from "./AppWebReportTaetigkeitsberichtPage";
import AppWebReportTagesberichtPage from "./AppWebReportTagesberichtPage";


function AppWebReportSwitchPage(props) {

    return (
<>
        {((!props.postleitzahlModal && props.reportType==="Stunden-Anmeldung")
        || (!props.postleitzahlModal && props.reportType==="Stunden-Abmeldung")) &&
                <AppWebReportStundenPage
                    reportData={props.reportData}
                    reportType={props.reportType}/>
        }

        {(!props.postleitzahlModal && props.reportType==="Tätigkeit") &&
                <AppWebReportTaetigkeitsberichtPage
                    reportData={props.reportData}
                    reportType={props.reportType}/>
        }

        {(!props.postleitzahlModal && props.reportType==="Tages") &&
                <AppWebReportTagesberichtPage
                    reportData={props.reportData}
                    reportType={props.reportType}/>
        }

</>

    );
}

export default memo(AppWebReportSwitchPage);
